import { Icon } from '../components/Icon.tsx';

/**
 * A1 — 로그인 (브라우저 판).
 *
 * 기획서의 A1 은 네이티브 셸이 그리는 화면입니다. 셸 없이 브라우저에서 열면
 * 그 화면이 없으므로 같은 자리를 웹앱이 대신 그립니다.
 *
 * 셸 판과 다른 점은 «자체 가입» 줄이 없다는 것 하나입니다 — A4·A5 가
 * MVP 제외라 눌러도 갈 곳이 없습니다. 없는 문을 그려 두지 않습니다.
 */

interface Props {
  onKakao: () => void;
  busy: boolean;
  failure: string | null;
}

export function Login({ onKakao, busy, failure }: Props) {
  return (
    <div className="screen">
      <div className="login">
        <div className="login__top">
          <p className="login__eyebrow">Log-In</p>
          <h1 className="login__title">PrayerLog</h1>
          <p className="login__sub">기도를 기록하고, 함께 나눕니다</p>
        </div>

        <div className="login__bottom">
          {/* 실패한 이유를 그대로 적습니다. 다시 누르기 전에 알아야 합니다 */}
          {failure && <p className="login__failure">{failure}</p>}

          <button type="button" className="btn-kakao" disabled={busy} onClick={onKakao}>
            <span className="btn-kakao__mark" aria-hidden="true" />
            {busy ? '로그인 중…' : '카카오로 3초 만에 시작하기'}
          </button>

          <p className="login__terms">
            계속하면 <u>이용약관</u> 및 <u>개인정보 처리방침</u>에
            <br />
            동의하는 것으로 봅니다
          </p>
        </div>
      </div>
    </div>
  );
}

/**
 * 로그인을 끝내고 돌아오는 중에 잠깐 보이는 화면 — A3.
 *
 * 인가 코드를 토큰으로 바꾸는 동안입니다. 보통 1초 아래라 스쳐 지나가지만,
 * 빈 화면을 두면 그 1초가 «멈춘 것»으로 읽힙니다.
 */
export function SigningIn() {
  return (
    <div className="screen">
      <div className="login">
        <div className="login__top">
          <span className="login__spinner" />
          <p className="login__sub">로그인 중입니다…</p>
        </div>
      </div>
    </div>
  );
}

/**
 * 서버 주소가 없는 빌드 — 목업으로 둘러보는 길.
 *
 * 로그인 자체가 불가능하므로 로그인 화면을 보여 주면 막다른 길입니다.
 * 대신 무엇이 빠졌는지 적고 미리보기로 들여보냅니다.
 */
export function NoServer({ onPreview }: { onPreview: () => void }) {
  return (
    <div className="screen">
      <div className="login">
        <div className="login__top">
          <p className="login__eyebrow">Log-In</p>
          <h1 className="login__title">PrayerLog</h1>
          <p className="login__sub">서버 주소가 설정되지 않은 빌드입니다</p>
        </div>
        <div className="login__bottom">
          <button type="button" className="btn btn--secondary" onClick={onPreview}>
            <Icon name="forward" size={16} />
            예시 데이터로 둘러보기
          </button>
          <p className="login__terms">저장·수정은 반영되지 않습니다.</p>
        </div>
      </div>
    </div>
  );
}
